<template>
    <div class="admin-config-page">
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{ trans('general.logo') }}</h3>
                    <div class="nk-block-des text-soft">
                        <p>Update the brand marks shown in the admin shell and public-facing surfaces.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="admin-config-layout admin-linear-page">
            <configuration-sidebar menu="logo"></configuration-sidebar>
            <div class="admin-config-panel">
                <div class="admin-config-panel__inner">
                    <div class="row admin-config-forms-row">
                        <div class="col-12 col-lg-6">
                            <section class="admin-config-section" :aria-label="trans('general.logo_type',{type:trans('general.sidebar')})">
                                <h4 class="admin-config-section__title">{{trans('general.logo_type',{type:trans('general.sidebar')})}}</h4>
                                <p class="admin-config-section__description">Used in the admin navigation and compact brand placements.</p>
                                <upload-image id="sidebar_logo" upload-path="/configuration/logo/sidebar" remove-path="/configuration/logo/sidebar/remove" :image-source="logo.sidebar" @uploaded="updateSidebarLogo" @removed="updateSidebarLogo"></upload-image>
                            </section>
                        </div>
                        <div class="col-12 col-lg-6">
                            <section class="admin-config-section" :aria-label="trans('general.logo_type',{type:trans('general.main')})">
                                <h4 class="admin-config-section__title">{{trans('general.logo_type',{type:trans('general.main')})}}</h4>
                                <p class="admin-config-section__description">Used wherever the full company mark is displayed.</p>
                                <upload-image id="logo" upload-path="/configuration/logo/main" remove-path="/configuration/logo/main/remove" :image-source="logo.main" @uploaded="updateMainLogo" @removed="updateMainLogo"></upload-image>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import configurationSidebar from '../system-config-sidebar'
    import uploadImage from '../../../components/upload-image'

    export default {
        components : { configurationSidebar,uploadImage },
        data() {
            return {
                logo: {
                    main: '',
                    sidebar: ''
                }
            }
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }
            this.logo.main = helper.getConfig('main_logo');
            this.logo.sidebar = helper.getConfig('sidebar_logo');
        },
        methods: {
            updateMainLogo(val){
                this.$store.dispatch('setConfig',{
                    main_logo: val
                });
            },
            updateSidebarLogo(val){
                this.$store.dispatch('setConfig',{
                    sidebar_logo: val
                });
            }
        }
    }
</script>
